import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, prescriptionData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(prescriptionData),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'OPD Prescription Report',
            }
        }

        pushIntoTable(doc, prescriptionData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (prescriptionData) => {
        return [
            {
                text:  'OPD Prescription Report',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '5%', '15%', '10%', '20%','15%', '35%' ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, prescriptionData) => {
        const tableItems = prescriptionData.data;
        const tableHeader = getTableHeader();
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item, i) => {
            const rowData = getRowData(item, i);
            return doc.content[1].table.body.push(rowData);
        });

        const getLastRow = getTotal(tableItems)
        doc.content[1].table.body.push(getLastRow);
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: '#SL'},
            {text: 'Billing Date & Time'},
            {text: 'Bill Number'},
            {text: 'Patient Name (ID)'},
            {text: 'Service Delivery Date & Time'},
            {text: 'Consultant'},
        ]

        return tableHeader
    }
    const getRowData = (item, i) => {

        const tableRow = [
            {text: i+1},
            {text: item.bill_date + ' ' + item.bill_time},
            {text: item.bill_number},
            {text: item.contact_profile_name + ' (' + item.serial_no + ')'},
            {text: item.formatted_updated_at},
            {text: item.service_resource_name},
        ]

        return tableRow
    }

    const getTotal = (tableItems) => {

        const lastRow = [
            {
                text: 'Total:',
                alignment: 'right',
            },

            {
                text: tableItems.length,
                colSpan:5
            },

            '','','',
        ]

        return lastRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;